<template>
  <div class="empty-layout">
    <slot></slot>
  </div>
</template>
